// Did THIS document load carry a Telegram Mini App payload in its own URL?
//
// Telegram Web and Telegram Desktop both hand the signed initData over as a
// `#tgWebAppData=...` hash param rather than pre-injecting it the way the
// native mobile clients do. main.tsx copies that value into sessionStorage
// before the hash router overwrites the hash — but sessionStorage outlives the
// navigation that filled it, so a later load in the same tab finds the blob
// with no way to tell whether it is this launch's payload or a leftover.
//
// Deliberately an in-memory module flag, not storage: its whole job is to be
// scoped to one document load. Anything persisted would inherit the staleness
// it exists to rule out.
let capturedThisLoad = false;

/** Called by main.tsx when the launch URL carried a `tgWebAppData` payload. */
export function markTelegramLaunchPayload(): void {
  capturedThisLoad = true;
}

/**
 * Whether the cached initData came from this document's own launch URL.
 *
 * Positive evidence of a real Telegram launch, which `display-mode` is not:
 * Telegram Desktop renders in a chromeless app window and so reports
 * `standalone`, exactly like an installed PWA. Keying the decision off the
 * window's appearance instead of the payload's provenance is what left
 * Desktop unable to sign in — the hash was its only source, and the
 * PWA-staleness guard threw it away.
 */
export function hasTelegramLaunchPayload(): boolean {
  return capturedThisLoad;
}
